import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appFormatPhoneUs]'
})
export class FormatPhoneUsDirective {
  private previousValue: string = '';

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    // Eliminar todos los caracteres no numéricos excepto el + al inicio si ya existe.
    let currentValue = value.replace(/[^\d]/g, '');
    if (!currentValue.startsWith('1') && this.previousValue !== '+1 ') {
      currentValue = '1' + currentValue; // Añade '1' para números de EE.UU. solo si es necesario.
    }

    const formattedValue = this.formatPhoneNumber(currentValue);

    if (this.el.nativeElement.value !== formattedValue) {
      this.el.nativeElement.value = formattedValue;
    }

    this.previousValue = formattedValue; // Guardar el valor actual para comparaciones futuras.
  }

  private formatPhoneNumber(value: string): string {
    if (!value) return '+1 ';

    // Extraer las partes del número de teléfono asumiendo un prefijo '1' para EE.UU.
    const areaCode = value.slice(1, 4);
    const middle = value.slice(4, 7);
    const last = value.slice(7);

    let result = '+1 ';
    if (value.length > 7) {
      result += `(${areaCode}) ${middle}-${last}`;
    } else if (value.length > 4) {
      result += `(${areaCode}) ${middle}`;
    } else if (value.length > 1) {
      result += `(${areaCode}`;
    }

    return result;
  }
}